import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    PageWrap: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontWeight: '600',

        '& .AddPaymentWidgetWrap': {
            width: '535px'
        }
    }
}));
